'use strict'

const { createCmd } = require('redux-serial-effects')

const TYPE = 'FIRE_EVENT'
const provider = (fireEvent, errorBoundaries) => ({
  type: TYPE,
  runner: cmd => {
    return errorBoundaries.userCodeZone(fireEvent)(
      cmd.eventType,
      ...cmd.payload
    )
  }
})

const fireEventCmd = (eventType, ...payload) =>
  createCmd(TYPE, false, {
    eventType,
    payload
  })

module.exports.provider = provider
module.exports.fireEventCmd = fireEventCmd



// WEBPACK FOOTER //
// ./helpers/fireEventProvider.js